import ShiftDetailPage from '../shiftDetail.page';
import { useCallback, useState } from 'react';
import useSearchString from '../../../hooks/UrlParamsHandler/useSearchParams';
import classNames from 'classnames';
import {
  ActionIcon,
  FavouriteIcon,
  ImageIcon,
  NavigationIcon,
} from '@tymbe/ui-icons';
import { ShiftDetailHistory } from './ShiftDetailHistory/ShiftDetailHistory';
import Options from './Options';
import feathersClient from '../../../apiClient';
import { useQuery } from 'react-query';
import { DeleteShiftModal } from './ModalDeleteShift';
import { DropDownMenuOption } from './ShiftDetail/DropDownMenu';

const ShiftDetailModal = () => {
  const [deleteShiftModal, setDeleteShiftModal] = useState(false);
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchString();
  const shiftId = searchParams.get('shiftId') || undefined;

  const toggle = () => {
    setDeleteShiftModal((prev) => !prev);
  };

  const { data: shift } = useQuery(['shiftDetail', shiftId], async () =>
    feathersClient.service('shift').get(shiftId, {
      query: {
        $eager:
          '[application(withDeleted).[person.personData(attendanceRate)], manShift.[canceledApplication.[person.personData(attendanceRate)], activeApplication.[person.personData], perk], branchoffice.parent, shiftTemplate, perk, documentType, company]',
        $modify: 'withApplicationCounts',
        $appendJuniorProp: true,
      },
    })
  );

  const toggleShowHistory = () => {
    setShowHistory((prev) => !prev);
  };

  const onShiftDetailClose = useCallback(() => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('shiftId');
    setSearchParams(newParams);
  }, [searchParams, setSearchParams]);

  const menuOptions: DropDownMenuOption[] = [
    {
      text: 'Upravit směnu',
      icon: <ImageIcon name="edit" className="text-secondary-400 size-4" />,
      link: `/shift/${shiftId}`,
    },
    {
      text: 'Smazat směnu',
      icon: (
        <FavouriteIcon name="delete" className="text-secondary-400 size-4" />
      ),
      onClick: () => {
        setDeleteShiftModal(true);
      },
    },
    {
      text: 'Upravit pozici',
      icon: <FavouriteIcon name="work" className="text-secondary-400 size-4" />,
      link: `/company/${shift?.company_id}/shift-template/${shift?.shift_template_id}`,
    },
    {
      text: 'Historie',
      icon: <ActionIcon name="history" className="text-secondary-400 size-4" />,
      onClick: () => {
        toggleShowHistory();
      },
    },
  ];

  return (
    <>
      <div
        className={classNames(
          'flex flex-col ty-shift-detail-area gap-4 max-h-full w-[396px] bg-bg p-6 rounded-lg overflow-y drop-shadow-lg',
          { hidden: !shiftId }
        )}
      >
        <div className="flex justify-between align-middle text-heading-4-xl text-secondary-600">
          {showHistory ? (
            <div className="flex justify-start items-center">
              <NavigationIcon
                name="west"
                onClick={toggleShowHistory}
                className="mr-2 size-5 cursor-pointer"
              />
              Historie
              <FavouriteIcon
                name="close"
                className="size-5 text-secondary-400 absolute right-2 top-2 cursor-pointer"
                onClick={onShiftDetailClose}
              />
            </div>
          ) : (
            <>
              Detail směny
              <Options
                menuOptions={menuOptions}
                className="text-secondary-400"
              />
              <FavouriteIcon
                name="close"
                className="size-5 text-secondary-400 absolute right-2 top-2 cursor-pointer"
                onClick={onShiftDetailClose}
              />
            </>
          )}
        </div>
        {showHistory ? (
          <ShiftDetailHistory shiftId={shiftId!} />
        ) : (
          <>
            <div className="flex items-center gap-2 text-caption-xl">
              <span className="truncate">{shift?.company?.name}</span>
              <FavouriteIcon
                name="chevron_right"
                className="size-4 p-0.5 text-secondary-400 bg-secondary-transparent-5 rounded-sm"
              />
              <span className="truncate">
                {shift?.branchoffice?.parent?.name}
              </span>
              <FavouriteIcon
                name="chevron_right"
                className="size-4 p-0.5 text-secondary-400 bg-secondary-transparent-5 rounded-sm"
              />
              <span className="truncate">{shift?.branchoffice?.name}</span>
            </div>
            <hr className="h-px bg-secondary-100 border-0 -mx-6" />
            <ShiftDetailPage toggleShowHistory={toggleShowHistory} />
          </>
        )}
      </div>

      <DeleteShiftModal isOpen={deleteShiftModal} toggle={toggle} />
    </>
  );
};

export default ShiftDetailModal;
